import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IShiftVtoModal } from './types';

import { useAppDispatch } from '@/hooks';
import { acceptVTO } from '@/store/slices/scheduleSlice';
import { BaseShiftModal, BaseShiftModalContent } from '@/components/agent/my-schedule';

const ShiftVtoModal = React.forwardRef<HTMLDivElement, IShiftVtoModal>((props, ref): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const options = {
      shiftAssnId: props.block.shiftAssnId,
      scheduleId: props.contract.scheduleId,
    };
    dispatch(acceptVTO(options));
  };

  return (
    <BaseShiftModal
      parentRef={props.parentRef}
      ref={ref}
      content={
        <BaseShiftModalContent
          {...props}
          label={t`mySchedule.vtoBaseShiftModal.label`}
          buttonSubmit={t`mySchedule.vtoBaseShiftModal.buttonAcceptVto`}
          handleSubmit={handleSubmit}
        />
      }
    />
  );
});

ShiftVtoModal.displayName = 'ShiftVtoModal';

export { ShiftVtoModal };
